import React from 'react';

import { ADDITIONAL_CRITERIA } from '@zego/content/common.json';
import { unit } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import Checklist from '@zego/components/Checklist';

const CHECKLIST_COPY = {
  title: 'Is a Zego Private Hire policy for me?',
  description:
    'The criteria for taking a Private Hire insurance policy with Zego is as follows:',
  lists: [
    {
      items: [
        'You have a private hire licence',
        'You have a full UK/EU driving licence',
        'You have had fewer than 3 at-fault claims in the last 3 years',
        'You are aged 21-75',
        'You live and work in England, Scotland, or Wales',
        'Your vehicle has 9 seats or fewer (including the driver’s seat)',
      ],
    },
  ],
  footerText: ADDITIONAL_CRITERIA,
};

const PrivateHireWorkProviders = () => (
  <View>
    <Spacer height={unit(11)} mobileHeight={unit(7)} />
    <Checklist {...CHECKLIST_COPY} />
    <Spacer height={unit(9)} mobileHeight={unit(7)} />
  </View>
);

export default PrivateHireWorkProviders;
